module.exports = __webpack_public_path__ + "img/arrow_drop_down.6bffe432.svg";